import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {getEventId} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useWidgetActions, useWidgetState} from '../../../../../hooks/state-provider'
import {getDayMonthText, getEventsForDay, getSelectedDate} from '../../../../../selectors/calendar-layout'
import {getCompId} from '../../../../../selectors/component'
import {PopupHeader} from '../header'
import {EventListItem} from './event-list-item'
import s from './event-list.scss'

export const EventList = () => {
  const {
    closeMonthlyCalendarPopup: closeMonthlyCalendarPopupAction,
    openMonthlyCalendarEvent: openMonthlyCalendarEventAction,
  } = useWidgetActions()
  const selectedDate = useWidgetState(getSelectedDate)
  const events = useWidgetState(state => getEventsForDay(state, selectedDate))
  const dateText = useWidgetState(state => getDayMonthText(state, selectedDate))
  const componentId = useWidgetState(getCompId)

  const openMonthlyCalendarEvent = (eventId: string) => {
    openMonthlyCalendarEventAction({eventId, selectedDate})
    setTimeout(
      () =>
        focusElement({
          selector: hookToAttributeSelector(DH.calendarPopupBackButton, {componentId}),
          canFocus: true,
          preventScroll: true,
        }),
      50,
    )
  }

  const closeMonthlyCalendarPopup = () => {
    closeMonthlyCalendarPopupAction()
    focusElement({
      selector: hookToAttributeSelector(DH.calendarCell(selectedDate), {componentId}),
      canFocus: true,
      preventScroll: true,
    })
  }

  return (
    <div className={s.container} data-hook="calendar-event-list">
      <PopupHeader eventList text={dateText} onClose={closeMonthlyCalendarPopup} />
      <ul className={s.scrollableList}>
        {events.map(event => {
          const eventId = getEventId(event)

          return (
            <EventListItem
              key={eventId}
              event={event}
              selectedDate={selectedDate}
              onClick={() => {
                openMonthlyCalendarEvent(eventId)
              }}
            />
          )
        })}
      </ul>
    </div>
  )
}
